import getToken from "./getToken";
import storeToken from "./storeToken";

export interface IOAuthAPI {
  storeToken(uid: string, token: string): Promise<void>;
  getToken(uid: string): Promise<string | undefined>;
}

const OAuth: IOAuthAPI = {
  storeToken,
  getToken
}

export default OAuth;